import {
  all,
  takeEvery,
  takeLatest,
  put,
  call,
  fork,
} from 'redux-saga/effects';
import { startSubmit, stopSubmit } from 'redux-form';
import { push } from 'connected-react-router';
import {
  manageTeamMembersActionTypes,
  manageTeamsActionTypes,
} from './ManageTeams.actionTypes';
import teamService from '../../services/team';
import manageTeamsService from '../../services/manageTeams';
import {
  addNotification,
  notificationStates,
} from '../../components/Notification';
import firebase from '../../config/firebase.config';
const database = firebase.firestore();

function* getMembersSaga({ payload }) {
  yield put({ type: manageTeamMembersActionTypes.GET_MEMBERS_PENDING });
  try {
    let { success, data } = yield call(
      manageTeamsService.getAllTeamMembersData,
      {
        ...payload,
      }
    );
    if (success) {
      yield put({
        type: manageTeamMembersActionTypes.GET_MEMBERS_SUCCESS,
        payload: { success: true, data: [...data] },
      });
    } else {
      yield put({
        type: manageTeamMembersActionTypes.GET_MEMBERS_FAILED,
        payload: { success: false, data: 'No data available' },
      });
    }
  } catch (e) {
    yield put({
      type: manageTeamMembersActionTypes.GET_MEMBERS_FAILED,
      payload: e,
    });
  }
}

function* updateEmployeeDetailsSaga({ payload }) {
  yield put({
    type: manageTeamMembersActionTypes.UPDATE_EMPLOYEE_DETAILS_PENDING,
  });
  try {
    const result = yield call(
      manageTeamsService.updateEmployeeDetails,
      payload
    );
    if (result.success) {
      yield put({
        type: manageTeamMembersActionTypes.UPDATE_EMPLOYEE_DETAILS_SUCCESS,
        payload: result,
      });
    } else {
      yield put({
        type: manageTeamMembersActionTypes.UPDATE_EMPLOYEE_DETAILS_FAILED,
        payload: { message: result.message },
      });
    }
  } catch (e) {
    yield put({
      type: manageTeamMembersActionTypes.UPDATE_EMPLOYEE_DETAILS_FAILED,
      payload: { message: e.message || 'Failed to update employee details' },
    });
  }
}

function* removeUserFromTeamSaga({ payload }) {
  yield put({
    type: manageTeamMembersActionTypes.REMOVE_USER_FROM_TEAM_PENDING,
  });
  try {
    const result = yield call(manageTeamsService.removeUsers, payload);
    if (result.success) {
      yield put({
        type: manageTeamMembersActionTypes.REMOVE_USER_FROM_TEAM_SUCCESS,
        payload: result,
      });
    } else {
      yield put({
        type: manageTeamMembersActionTypes.REMOVE_USER_FROM_TEAM_FAILED,
        payload: { message: result.message },
      });
    }
  } catch (e) {
    yield put({
      type: manageTeamMembersActionTypes.REMOVE_USER_FROM_TEAM_FAILED,
      payload: {
        message: e.message || 'Failed to remove user from department',
      },
    });
  }
}

function* getTeamsSaga({ payload }) {
  yield put({ type: manageTeamsActionTypes.GET_TEAMS_PENDING });
  try {
    let { success, data } = yield call(teamService.getAllTeamMembers, {
      ...payload,
    });
    if (success) {
      yield put({
        type: manageTeamsActionTypes.GET_TEAMS_SUCCESS,
        payload: { success: true, data: [...data] },
      });
    } else {
      yield put({
        type: manageTeamsActionTypes.GET_TEAMS_FAILED,
        payload: { success: false, data: 'No data available' },
      });
    }
  } catch (e) {
    yield put({ type: manageTeamsActionTypes.GET_TEAMS_FAILED, payload: e });
  }
}

function* manageTeamsWatcher() {
  yield all([takeEvery(manageTeamsActionTypes.GET_TEAMS, getTeamsSaga)]);
}

function* manageTeamMembersWatcher() {
  yield all([
    takeEvery(manageTeamMembersActionTypes.GET_MEMBERS, getMembersSaga),
    takeEvery(
      manageTeamMembersActionTypes.UPDATE_EMPLOYEE_DETAILS,
      updateEmployeeDetailsSaga
    ),
    takeEvery(
      manageTeamMembersActionTypes.REMOVE_USER_FROM_TEAM,
      removeUserFromTeamSaga
    ),
  ]);
}
export default function* manageTeamsRootWatcher() {
  yield all([fork(manageTeamMembersWatcher), fork(manageTeamsWatcher)]);
}
